// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".stat-element[data-v-e3308752]{padding:20px;text-align:center;box-shadow:1px 2px 3px #000;border-radius:8px;background:#fff;color:#464a57;overflow:hidden;font-size:25px}", ""]);
// Exports
module.exports = exports;
